module.exports = __webpack_public_path__ + "img/expand-arrow-down-medium-disabled.d5351292.svg";